import React from "react";
import { Stack, Typography } from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";

interface Props {}

const WhyChooseContent = (props: Props) => {
	return (
		<Stack spacing={2}>
			<Typography variant="body2" color="text.secondary">
				Tạo ít nhất 2 đối tượng và tối đa 4.
			</Typography>
			<Field.Text
				name="stepResource.objects[0]"
				label="Đối tượng 1"
			/>
			<Field.Text
				name="stepResource.objects[1]"
				label="Đối tượng 2"
			/>
			<Field.Text
				name="stepResource.objects[2]"
				label="Đối tượng 3"
			/>
			<Field.Text
				name="stepResource.objects[3]"
				label="Đối tượng 4"
			/>
		</Stack>
	);
};

export default WhyChooseContent;
